import { render, staticRenderFns } from "./CheckoutFlow.vue?vue&type=template&id=2b115a72&scoped=true"
import script from "./CheckoutFlow.vue?vue&type=script&lang=js"
export * from "./CheckoutFlow.vue?vue&type=script&lang=js"
import style0 from "./CheckoutFlow.vue?vue&type=style&index=0&id=2b115a72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b115a72",
  null
  
)

export default component.exports